import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { QRCodeComponent } from 'angularx-qrcode';
import { MessageService } from 'primeng/api';
import { AllUsers, UserData } from '../../Models/Authentication/UserModel';
import { NotificationMessages } from '../../Models/Notifications/NotifiyMessages';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { Capacitor } from '@capacitor/core';
import { NavigationService } from '../../Services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';


@Component({
  selector: 'app-admin-nav',
  templateUrl: './admin-nav.component.html',
  styleUrls: ['./admin-nav.component.css'],standalone:false
})
export class AdminNavComponent extends BaseComponent  implements OnInit{
  @ViewChild('qrcode', { static: true }) qrcode!: QRCodeComponent;
  changelog: string = 'v3.1.0';
  isDarkTheme: boolean = false;
  shouldReloadPage = false;
  selectedLanguage: string = 'en';
  sidebarVisible: boolean = false;
  Users:AllUsers[]=[];

  userId:string;
  user!:UserData
  userRole!:string
  users: AllUsers[] = []; // Replace with your actual user data
  selectedUser: any;
  loading:boolean=false;
  img:string='../../../assets/images/fr.PNG';
  latestTimestamp!: string;
  notifications:NotificationMessages[]=[]
  deals:NotificationMessages[]=[]
  isSticky: boolean = false;
  username:string="https://touchconnectapp.web.app/"
  isScrolled = false;
  isMobile: boolean = false;
  currentLanguage: string = 'fr'; // Default language
  constructor
  (
      
      private renderer: Renderer2,
      private http:HttpClient,
      private auth:AuthService,
      private messageService:MessageService,
      private Router:Router,
      private el: ElementRef,
      private api:BaseApiService,
      private navigationService: NavigationService,
      private translate :TranslateService,
      private ngZone: NgZone
  )
  {
    super();
    this.userId=this.auth.getUID();
    this.userRole=this.auth.getRoles().toString();
     const savedLanguage = localStorage.getItem('selectedLanguage');
     if (savedLanguage) {
       this.selectedLanguage = savedLanguage;
  }


     this.setDirection(this.selectedLanguage);
   }


   @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.isScrolled = scrollTop > 50;
  }
  

  async switchLanguage(event: Event): Promise<void> {
    const selectedLanguage = (event.target as HTMLSelectElement).value;
    this.currentLanguage = selectedLanguage;

    // Use ngx-translate to switch the language
    this.translate.use(selectedLanguage);

    // Detect platform and store the selected language
    const info = await Device.getInfo();
    if (info.platform === 'ios') {
      await Preferences.set({
        key: 'language',
        value: selectedLanguage,
      });
    } else {
      localStorage.setItem('language', selectedLanguage);
    }
  }





  showSidebar: boolean = true;
  showSide:boolean=false;

  downloadQRCode() {
    // Find the QR code element by class name
    const qrcodeElement = this.el.nativeElement.querySelector('.qrcode');

    if (qrcodeElement) {
      // Get the canvas element within the QR code component
      const canvas = qrcodeElement.querySelector('canvas');

      if (canvas) {
        // Convert the canvas content to a data URL
        const url = canvas.toDataURL();

        // Create an anchor element
        const a = this.renderer.createElement('a');
        // Set its href to the data URL of the QR code
        a.href = url;
        // Set the download attribute to specify the file name
        a.download = 'qrcode.png';

        // Append the anchor element to the body and trigger a click event
        this.renderer.appendChild(document.body, a);
        a.click();
        // Remove the anchor element from the DOM
        this.renderer.removeChild(document.body, a);
      } else {
      }
    } else {
    }
   }

   GetPkPass(userId:string)
   {
    this.loading = true;
    const url = `Auth/MembershipCard?userId=${userId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.apple.pkpass'
    });

    this.http.get(url, {
      headers: headers,
      responseType: 'blob' // Set response type to blob for file download
    }).pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    ).subscribe(
        {
          next:  (response: Blob) => {
            // Create a blob URL for the file
            const blob = new Blob([response], { type: 'application/vnd.apple.pkpass' });
            const url = window.URL.createObjectURL(blob);
            // Create a link element and click it to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = userId.substring(0,3)+".pkpass";
            document.body.appendChild(link);
            link.click();
        
            // Clean up
            window.URL.revokeObjectURL(url);
            this.loading = false;
          },
          error: (error) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
          }
        }
    );

  }


  toggleColumnLayout() {

    this.showSidebar = !this.showSidebar;
    if (this.showSidebar) {

      this.renderer.addClass(document.querySelector('#db-wrapper'), 'toggled');
    } else {

      this.renderer.removeClass(document.querySelector('#db-wrapper'), 'toggled');


    }




  }

  GetNotifications(userId:string){
    this.loading=true;
    this.api.read(`Profile_Service/Notifications?userid=${userId}&type=Alert`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    ).subscribe
    (
      {
        next:  (response)=>{
          this.notifications   = response;
          this.latestTimestamp = this.findLatestTimestamp();
          this.loading         = false;
        },
        error: (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }





  logut(){
    this.auth.logout();
    this.Router.navigate(['/login'])
  }
  isRouteActive(routes: string[]): boolean {
    const currentUrl = this.Router.url;
    if(routes.some(route => currentUrl.startsWith(route))){
      return true;
    }
    else{
      return routes.some(route => this.Router.isActive(route, true));
    }
  }
  private findLatestTimestamp(): string {
    let latestTimestamp = '';

    for (const notification of this.notifications) {
      if (!latestTimestamp || new Date(notification.timestamp) > new Date(latestTimestamp)) {
        latestTimestamp = notification.timestamp;
      }
    }

    return latestTimestamp;
  }
  toggleFullScreen() {
    const doc = window.document as any;
    const docEl = doc.documentElement as any;  // Cast docEl to any

    const requestFullScreen = docEl.requestFullscreen || docEl.webkitRequestFullscreen || docEl.msRequestFullscreen;
    const exitFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (!doc.fullscreenElement ) {
      // Enter full-screen mode
      if (requestFullScreen) {
        requestFullScreen.call(docEl);
      }
    } else {
      // Exit full-screen mode
      if (exitFullScreen) {
        exitFullScreen.call(doc);
      }
    }
  }

  getClassForRoute(route: string): string {
    const isActive = this.Router.isActive(route, true);

    if (isActive) {
      return 'nav-link u-sidebar-nav-menu__link active smooth-shadow-lg mb-1';
    } else {
      return 'nav-link u-sidebar-nav-menu__link mb-1';
    }
  }

   ShowPannel(){
    this.sidebarVisible=true;
   }

  searchUsers(event: any) {

    const query = event.query.toLowerCase();
    this.users = this.Users.filter((user) =>
      user.name.toLowerCase().includes(query) ||
      user.email.toLowerCase().includes(query)
    );

  }

  getdata(uid:any){
    this.loading=true;
    this.api.read(`Auth/getByIdDT?uid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.user = response;
          this.username=this.username+this.user.userName
          this.loading=false;
        },
        error:(error)=>{
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }

  onSelectUser(event: any) {
    try {

      this.Router.navigate(['/',event.name]); // Example navigation
    } catch (error) {

    }
  }

  getUser(){
    this.loading=true;
    this.api.read("Auth/GetusersAll")
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.loading=false;
          this.Users = response;
  
        },
        error:
        (
          error
        )=>{
         this.loading=false;
         this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }

  logOut(){
    this.auth.logout();
    this.Router.navigate(['/login']);
  }

  goBack(): void {
    this.navigationService.goBack();
  }

  goHome() {
    this.navigationService.navigate('/ManueDash');
   //window.location.href = '/ManueDash';
   this.ngZone.run(() => {
    this.Router.navigateByUrl('/ManueDash');
  });
  
  }
  async ngOnInit() {
    // Detect platform
    const info = await Device.getInfo();

    let storedLanguage = 'en'; // Default language
    if (info.platform === 'ios') {
      const langPref = await Preferences.get({ key: 'language' });
      storedLanguage = langPref.value || 'en';
    } else {
      storedLanguage = localStorage.getItem('language') || 'en';
    }
    this.isMobile = Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
    
    if (this.isMobile) {
      this.renderer.addClass(document.body, 'mobile-platform');
    }
    this.userRole=this.auth.getRoles().toString();
    if(this.userRole=="Administrator")
    {
      this.getUser()
    }
    if(this.userId!=''){
      this.GetNotifications(this.userId);
      this.getdata(this.userId)
    }
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      this.isDarkTheme = true;
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      this.isDarkTheme = false;
      document.documentElement.setAttribute('data-theme', 'light');
    }

  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
    if (this.isDarkTheme) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }

  }



  changeLanguage(language: string) {
    localStorage.setItem('selectedLanguage', language);
    this.shouldReloadPage = true;
    this.setDirection(language);
  }

  private setDirection(language: string) {
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', direction);

  }
}

